import { Component, forwardRef, Input } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

export interface GpsLocation {
  lat: number
  long: number
}

@Component({
  selector: 'app-map-control',
  templateUrl: './map-control.component.html',
  styleUrls: ['./map-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MapControlComponent),
      multi: true,
    },
  ],
})
export class MapControlComponent implements ControlValueAccessor {
  @Input() zoom = 14
  @Input() height = '300px'

  location: GpsLocation = {
    lat: 0,
    long: 0,
  }

  disabled = false

  // ControlValueAccessor implementation
  private onChange: (value: GpsLocation) => void = () => {}
  private onTouched: () => void = () => {}

  writeValue(location: GpsLocation): void {
    if (location) {
      this.location = location
    }
  }

  registerOnChange(fn: (value: GpsLocation) => void): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  onMarkerChange(event: { latLng: { lat: () => number; lng: () => number } }): void {
    if (this.disabled) return

    this.location = {
      lat: event.latLng.lat(),
      long: event.latLng.lng(),
    }
    this.onChange(this.location)
    this.onTouched()
  }
}
